import { SVGProps } from "react"

export const WifiIcon = ({
	signal,
	...props
}: SVGProps<SVGSVGElement> & { signal?: number }) => {
	const hasSignal = signal !== undefined
	const getOpacity = (threshold: number) => {
		if (!hasSignal) {
			return undefined
		}
		if (threshold === 0) {
			return 1
		}
		return signal > threshold ? 1 : 0.5
	}

	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12 18.67h.01"
				strokeWidth="3"
				opacity={getOpacity(0)}
				fillOpacity={getOpacity(0)}
				strokeOpacity={getOpacity(0)}
			/>
			<path
				d="M9.08 15.75a4.17 4.17 0 0 1 5.83 0"
				opacity={getOpacity(25)}
				fillOpacity={getOpacity(25)}
				strokeOpacity={getOpacity(25)}
			/>
			<path
				d="M6.17 12.83a8.33 8.33 0 0 1 11.67 0"
				opacity={getOpacity(50)}
				fillOpacity={getOpacity(50)}
				strokeOpacity={getOpacity(50)}
			/>
			<path
				d="M3.25 9.92a12.5 12.5 0 0 1 17.5 0"
				opacity={getOpacity(75)}
				fillOpacity={getOpacity(75)}
				strokeOpacity={getOpacity(75)}
			/>
		</svg>
	)
}
